import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnDestroy, ViewChild } from '@angular/core';
import { AlertController, IonicModule, IonSelect, ModalController } from '@ionic/angular';
import { Tournament } from '../../../_shared/models/tournament.model';
import { VenuesService } from '../../../venues/venues.service';
import { AsyncPipe } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { Venue } from '../../../_shared/models/csTypes/venue';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tournament-venues',
  templateUrl: './tournament-venues.component.html',
  styleUrls: ['./tournament-venues.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonicModule,
    AsyncPipe,
    TranslateModule
  ]
})
export class TournamentVenuesComponent implements OnDestroy {
  private modalCOntroller = inject(ModalController);
  private alertController = inject(AlertController);
  private venuesService = inject(VenuesService);
  private cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) tournament!: Tournament;
  @ViewChild('select') select: IonSelect;

  venues$ = this.venuesService.myVenues();

  private readonly destroy$: Subject<void> = new Subject();

  constructor() { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addVenue(): void {
    if (this.select.value) {
      const venue: Venue = this.select.value;

      this.venuesService.addToTournament(this.tournament._id, venue._id).pipe(
        takeUntil(this.destroy$)
      ).subscribe(() => {
        this.tournament.venues.push(venue);
        this.select.value = null;
        this.cdr.detectChanges();
      })
    }


  }

  async removeVenue(_venueId: string, index: number): Promise<void> {

      const alert = await this.alertController.create({
        header: 'Remove venue',
        message: 'Are you sure that you want to remove this venue?',
        buttons: [{
          text: 'Yes, remove',
          role: 'destructive',
          handler: () => {
            this.venuesService.removeFromTournament(this.tournament._id, _venueId).pipe(
              takeUntil(this.destroy$)
            ).subscribe(() => {
              this.tournament.venues.splice(index, 1);
              this.cdr.detectChanges();
            })
          }
        }, {
          text: 'Cancel',
          role: 'cancel'
        }]
      });

      await alert.present();

  }

  async close() {
    await this.modalCOntroller.dismiss();
  }

}
